import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="chapter-toggle"
// Attach to .chapter-toggle elements
export default class extends Controller {
  toggle() {
    const list = this.element.nextElementSibling
    if (list && list.tagName === 'UL') {
      list.classList.toggle('open')
    }
    const caretIcon = this.element.querySelector('.fa-caret-right, .fa-caret-down')
    if (caretIcon) {
      caretIcon.classList.toggle('fa-caret-right')
      caretIcon.classList.toggle('fa-caret-down')
    }
  }
}
